import Footer, { FooterProps } from '@/components/shared/Footer';
import Header from '@/components/shared/Header';
import Sidebar from '@/components/shared/Sidebar/Sidebar';

import { styled } from '@mui/system';
import { useSidebarNavigation } from '@/contexts/sidebarNavigationContext';
import { useLocation } from 'react-router-dom';
import Box from '@mui/system/Box';
import React from 'react';

const Layout = styled('main')({});

type Props = {
  children: React.ReactNode;
  FooterProps?: FooterProps;
  HeaderProps?: HeaderProps;
  displayPageLayout?: string;
  noPadding?: boolean;
};

export function PageLayout({
  children,
  FooterProps = {},
  HeaderProps = {},
  displayPageLayout = '',
  noPadding = false,
}: Props) {
  const { showSettingsSidebar, secondarySidebarData, activeSettingsLink } = useSidebarNavigation();
  const location = useLocation();
  const hasActiveSettingsSection = Boolean(activeSettingsLink.activeSection);
  const isSettingsDrawerOpen = showSettingsSidebar && !hasActiveSettingsSection;
  const hasVisibleSecondarySidebar =
    !secondarySidebarData.isEmpty && !isSettingsDrawerOpen && !hasActiveSettingsSection;
  const calculatedMarginLeft = location.pathname.includes('workinprogress')
    ? '65px'
    : hasActiveSettingsSection
      ? '275px'
      : hasVisibleSecondarySidebar
        ? '215px'
        : '65px';

  return (
    <Layout
      className={
        displayPageLayout === 'no' ? 'page-layout-embedded' : 'modern-form-page page-layout-modern'
      }
      sx={
        displayPageLayout === 'no'
          ? {}
          : {
              marginLeft: calculatedMarginLeft,
              transition: 'margin-left .28s ease',
              minHeight: '100vh',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              backgroundColor: 'background.default',
              overflowX: 'clip',
            }
      }
    >
      {displayPageLayout !== 'no' && <Sidebar {...FooterProps} />}
      {displayPageLayout !== 'no' && <Header {...HeaderProps} />}

      <Box
        sx={
          displayPageLayout === 'no'
            ? {}
            : noPadding
              ? {
                  flex: '1 1 auto',
                  minHeight: 0,
                  minWidth: 0,
                  padding: { xs: '0 0 1.5rem', sm: '56px 0 2rem', md: '56px 0 2.5rem' },
                }
              : {
                  flex: '1 1 auto',
                  minHeight: 0,
                  minWidth: 0,
                  padding: {
                    xs: '56px 1rem 1.5rem',
                    sm: '56px 1.5rem 2rem',
                    md: '56px 2rem 2.5rem',
                    lg: '56px 2.5rem 2.75rem',
                  },
                }
        }
      >
        {children}
      </Box>

      {displayPageLayout !== 'no' && <Footer {...FooterProps} />}
    </Layout>
  );
}

type HeaderProps = any;
